export default __webpack_public_path__ + "static/media/icon-prev-double.7f79717f.svg";